import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDConfirmationDialog, FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import {
  ExecuteSelectLoadingPage,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/ExecuteSelectLoadingPage';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PM2JourneyRoadmapAdjustmentDiffSection, sectionMetaOverrideSet } from './section';

export const PM2JourneyRoadmapAdjustmentDiffLayout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const scheduleRel = resource.withRelationship(fr.relationships.scheduleMeeting.name,
    (rel) => rel,
    () => null);

  const handleConfirm = async () => {
    setShowConfirm(false);

    if (scheduleRel === null) {
      return;
    }

    setIsLoading(true);
    try {
      openModal(modalConsts.mcScheduler, [
        { link: scheduleRel.link('related').url() },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = async () => {
    setShowConfirm(true);
  };

  if (saving) {
    return <ExecuteSelectLoadingPage resource={resource} />;
  }

  return (
    <FDStack direction="column" spacing={3} flex={1} paddingY={4} alignItems="center">
      {!saving && <MetaControlField attr="title" />}
      <FDStack direction={'column'} spacing={5} alignItems={'center'}>
        <FDStack direction={'column'} alignItems={'center'} maxWidth={600}>
          {resource.attr('subtitle').map(text => <FDBodyText size={'lg'} value={text} align={'center'} />)}
        </FDStack>
        <FDStack direction={'column'} spacing={2} alignItems={'center'}>
          <MetaCollectionRenderer collection={resource.attr('sections')} layout={PM2JourneyRoadmapAdjustmentDiffSection} metaOverrideSet={sectionMetaOverrideSet} />
        </FDStack>
        <FDStack direction="row" justifyContent="flex-start" spacing={2}>
          {scheduleRel !== null && (
            <FDSecondaryActionButton
              {...dataAttrs('pm2-adjustment-diff-schedule-meeting-button')}
              label={scheduleRel?.meta('prompt') || 'Schedule a new review'}
              onClick={handleClick}
              loading={isLoading}
              alignSelf={'flex-start'}
              size="lg"
            />
          )}
          <FDPrimaryActionButton
            size="lg"
            {...dataAttrs('submit-btn')}
            onClick={onSubmit}
            label={resource.attr('primaryActionLabel') || 'Submit'}
          />
        </FDStack>
      </FDStack>
      <FDConfirmationDialog
        title={'Ready to schedule?'}
        message={'I\'m stopping my screen share now so we can book our next meeting.'}
        confirmLabel={'Leave and schedule'}
        loading={isLoading}
        open={showConfirm}
        onClose={() => {
          setShowConfirm(false);
        }}
        onConfirm={handleConfirm}
      />
    </FDStack>
  );
};
